import { Info } from "@mui/icons-material";
import { styled } from "@mui/material";

export default styled(Info)({
  fontSize: "14px",
  marginLeft: "4px",
  marginBottom: "-4px",
  cursor: "pointer",
});
